import r from "styled-components";
import p from "./atoms-v21018.js";
import { breakpoints as n } from "./atoms-v2125.js";
import { TEXTAREA_HEIGHT as e } from "./atoms-v2810.js";
import { Input as a } from "./atoms-v2777.js";
import { SkeletonRow as c } from "./atoms-v2778.js";
import { getColor as s } from "./atoms-v2815.js";
const u = r(p)`
  ${a}

  ${({ theme: o }) => {
  var t;
  return (t = o == null ? void 0 : o.get("tokens.body.compact-productive")) == null ? void 0 : t.toJS();
}}

  appearance: textfield;
  background-color: transparent;
  color: ${({ $colorTheme: o = "light", disabled: t, theme: i }) => s({ colorTheme: o, disabled: t, theme: i })};
  flex-grow: 1;
  height: ${({ $autoSize: o }) => o ? "auto" : `${e}px`};
  min-height: ${e}px;
  min-width: 0;
  padding: ${({ $variant: o }) => o === "expressive" ? 0 : "16px 18px"};
  resize: none;

  @media ${n.medium} {
    ${({ theme: o }) => {
  var t;
  return (t = o == null ? void 0 : o.get("tokens.body.compact-expressive")) == null ? void 0 : t.toJS();
}}
  }
`, k = r(c)`
  column-gap: 1px;
  display: flex;
  height: ${e}px;
  justify-content: end;
`, y = r.div`
  column-gap: 18px;
  display: flex;
  justify-content: space-between;
`, v = r.div`
  ${({ theme: o }) => {
  var t;
  return (t = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : t.toJS();
}}
  flex-grow: 1;
  text-align: right;
`;
export {
  y as Footer,
  v as MaxLength,
  k as SkeletonTextarea,
  u as Textarea
};
